'use strict';

export default class ProductDetailCalc {
	constructor(root) {
		if (!root) return false;

		this.root = root;

		this._matchHTML();
		this._calc();
		this._fieldHandler();
		this._expander();
	}

	_matchHTML() {
		this.field = this.root.querySelector('[data-calculator-field]');
		this.result = this.root.querySelector('[data-calculator-result]');
		this.expander = this.root.querySelector('[data-expander]');
		this.container = this.root.querySelector('[data-container]');
		this.sum = this.root.querySelector('[data-calculator-sum]');
	}

	_calc() {
		const attrs = '?action=calculate';
		const calcId = this.root.dataset.calculatorId;
		const itemId = this.root.dataset.calculatorItemId;
		const paramName = this.field.getAttribute("name");
		const url = this.root.dataset.calculatorAction;

		let data = {
			CALC_ID: calcId,
			ITEM_ID: itemId
		}

		data[paramName] = this.field.value;

		data = $.param(data);

		$.ajax({
			url: url + attrs,
			type: "POST",
			dataType: "JSON",
			data: data,
			beforeSend: () => {
				this.field.disabled = true;
			},
			success: (res) => {
				this.field.disabled = false;
				this.field.focus();

				if (res.result) {
					this.result.value = res.count;
					this.sum.innerText = res.summ;
				}
			}
		});
	}

	_fieldHandler(){
		this.field.addEventListener('input', e => {
			this._calc();
		});
	}

	_expander(){
		this.expander.addEventListener('click', e => {
			e.preventDefault();

			if (!this.container.classList.contains('is-expanded')){
				$(this.container).slideDown(_ => {
					this.container.classList.add('is-expanded');
				})
			} else {
				this.container.classList.remove('is-expanded');
				$(this.container).slideUp();
			}
		});
	}
}
